const BASE = process.env.REACT_APP_API_URL || '';

class ApiError extends Error {
  constructor(message, status, code) {
    super(message);
    this.status = status;
    this.code   = code;
  }
}

async function api(path, opts = {}) {
  const res  = await fetch(`${BASE}${path}`, {
    credentials: 'include',                          // send HttpOnly cookie automatically
    headers: { 'Content-Type': 'application/json', ...opts.headers },
    ...opts,
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new ApiError(data?.error || res.statusText, res.status, data?.code || 'UNKNOWN');
  }
  return data;
}

// Auth
export const loginWithGoogle = (token) =>
  api('/api/auth/google', { method: 'POST', body: JSON.stringify({ token }) });
export const getMe    = () => api('/api/auth/me');
export const logout   = () => api('/api/auth/logout', { method: 'POST' });

// Alpaca
export const getAlpacaStatus    = () => api('/api/alpaca/status');
export const getAlpacaConnectUrl = () => api('/api/alpaca/connect').then(d => d.url);
export const disconnectAlpaca   = () => api('/api/alpaca/disconnect', { method: 'POST' });

// Portfolio
export const getPortfolio = () => api('/api/portfolio');

// Proposals
export const getProposals     = () => api('/api/proposals');
export const approveProposal  = (id, body = {}) => api(`/api/proposals/${encodeURIComponent(id)}/approve`, { method: 'POST', body: JSON.stringify(body) });
export const rejectProposal   = (id) => api(`/api/proposals/${encodeURIComponent(id)}/reject`,  { method: 'POST' });
export const modifyProposal   = (id, qty) => api(`/api/proposals/${encodeURIComponent(id)}/modify`, { method: 'POST', body: JSON.stringify({ qty }) });

// Orders
export const getOrders    = () => api('/api/orders');
export const cancelOrder  = (id) => api(`/api/orders/${encodeURIComponent(id)}/cancel`, { method: 'POST' });
export const cancelAll    = () => api('/api/orders/cancel-all', { method: 'POST' });

// Quick Trade
export const quickTrade = (symbol, side, qty) =>
  api('/api/trade', { method: 'POST', body: JSON.stringify({ symbol, side, qty }) });

// Signals (S3 daily_signals)
export const getSignals          = () => api('/api/signals');            // both views
export const getSignalsByConsensus = () => api('/api/signals/consensus'); // grouped by consensus label
export const getSignalsAsProposals = () => api('/api/signals/proposals'); // mapped to order_type
export const getStockIndicators  = (symbols) => api(`/api/signals/indicators?symbols=${symbols.join(',')}`);

// Smart Proposals
export const getSmartProposals = () => api('/api/proposals/smart');

// Portfolio Performance
export const getPortfolioPerformance = (period = '1Y') => api(`/api/portfolio/performance?period=${period}`);
export const getPortfolioIndicators = (symbols) => api(`/api/portfolio/indicators?symbols=${symbols.join(',')}`);

// Preferences
export const getPreferences  = () => api('/api/preferences').then(d => d.preferences);
export const savePreferences = (prefs) => api('/api/preferences', { method: 'POST', body: JSON.stringify(prefs) });
export { ApiError };
